import { render } from "./FooterView.vue?vue&type=template&id=0e11b72a&scoped=true"
import script from "./FooterView.vue?vue&type=script&lang=js"
export * from "./FooterView.vue?vue&type=script&lang=js"

import "./FooterView.vue?vue&type=style&index=0&id=0e11b72a&scoped=true&lang=css"

import exportComponent from "D:\\도연희\\vuestudy\\vue-geoje\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e11b72a"]])

export default __exports__